import { useScreenShareParticipant } from './use-screen-share-participant';
import { useVideoContext } from './use-video-context';

export const SHARE_IN_PROGRESS_TEXT = 'Cannot share screen when another user is sharing';
export const SHARE_NOT_SUPPORTED_TEXT = 'Screen sharing is not supported with this browser';

export const useLocalScreenShareToggle = () => {
  const screenShareParticipant = useScreenShareParticipant();
  const { toggleScreenShare, isSharingScreen, room } = useVideoContext();
  const localParicipant = room?.localParticipant;
  const isScreenShareSupported = navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia;

  let disableScreenShareToggle: boolean | string = false;

  if (screenShareParticipant && screenShareParticipant?.identity !== localParicipant?.identity) {
    disableScreenShareToggle = SHARE_IN_PROGRESS_TEXT;
  }

  if (!isScreenShareSupported) {
    disableScreenShareToggle = SHARE_NOT_SUPPORTED_TEXT;
  }

  return {
    toggleScreenShare,
    disableScreenShareToggle,
    isScreenShareEnabled: isSharingScreen
  };
};
